import { isBrowser } from 'src/utils/platform';
import { IDebugEnv } from '../../types';
const defaultEnv = __DEV__
    ? isBrowser
        ? IDebugEnv.DEV
        // : IDebugEnv.DEV
        : IDebugEnv.PRE_PROD
    : IDebugEnv.PROD;
export const getDefaultDebugSettingsState = () => ({
    env: defaultEnv,
    webEnv: defaultEnv,
    disableHotReload: false,
});
